var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{attrs:{"width":"100%","height":"250px","options":_vm.chartOptions,"series":_vm.barChartSeries}})}
var staticRenderFns = []

export { render, staticRenderFns }